import { type ColumnType, type Selectable } from 'kysely'
import { z } from 'zod'

/** Represents the view public.cable_last_calibration_ */
export default interface CableLastCalibrationTable {
  /** Database type: pg_catalog.int4 */
  cableId: ColumnType<number, never, never>

  /** Database type: pg_catalog.int4 */
  cableSerial: ColumnType<number | null, never, never>

  /** Database type: pg_catalog.text */
  sensorId: ColumnType<string, never, never>

  /** Database type: pg_catalog.int4 */
  calibrationId: ColumnType<number, never, never>

  /** Database type: pg_catalog.int4 */
  sensorNumber: ColumnType<number, never, never>

  /** Database type: pg_catalog.numeric */
  calibrationOffset: ColumnType<number, never, never>

  /** Database type: pg_catalog.timestamptz */
  calibrationDate: ColumnType<Date, never, never>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date, never, never>
}

export type CableLastCalibration = Selectable<CableLastCalibrationTable>

export const cableLastCalibration = z.object({
  cableId: z.number(),
  cableSerial: z.number().nullable().optional(),
  sensorId: z.string(),
  calibrationId: z.number(),
  sensorNumber: z.number(),
  calibrationOffset: z.number(),
  calibrationDate: z.coerce.date(),
  createdAt: z.coerce.date(),
}) as unknown as z.Schema<CableLastCalibration>
